import { Button } from '@mm/components';
import { useContactsCRUDActions } from '@mm/state/actions/ContactsCRUDActions';
import { useViewActions } from '@mm/state/actions/viewActions';
import { MyLeadsSearchQuery } from '@mm/state/interfaces/myLeads';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { selectContacts } from '@mm/state/selectors/contactsSelector';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { Divider } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useImportContactsPermission } from '../../../../../common/hooks/use-import-contacts-permission';
import styles from './Contacts.module.css';
import { MyLeadsContactsTable } from './MyLeadsContactsTable/MyLeadsContactsTable';
import { MyLeadsFilterBar } from './MyLeadsFilterBar/MyLeadsFilterBar';
import { MyLeadsFiltersPanel } from './MyLeadsFiltersPanel/MyLeadsFiltersPanel';
import { useFilterParams } from './MyLeadsFiltersPanel/use-filter-params';
import { useFilterMyLeads } from './use-filter-my-leads';

export const Contacts = () => {
  const [filterParams, setFilterParams] = useState<MyLeadsSearchQuery>({
    query: {},
  });

  const { busy } = useFilterMyLeads({
    fetchAttributes: true,
    filterParams,
  });

  const { openImportContactListModal } = useModalActions();
  const { showSlideoutMenu } = useViewActions();
  const { retrieveAll, resetAllContacts } = useContactsCRUDActions();
  const uploadContactsPermission = useImportContactsPermission();
  const onImportClick = () => openImportContactListModal();
  const fbPageId = useSelector(activeFacebookPageIdSelector);
  const contacts = useSelector(selectContacts);
  const totalContacts = contacts.pagination.total;
  const { hasFilters } = useFilterParams({ filterParams });

  useEffect(() => {
    // retrieving 1 contact per page because we only need pagination object with total count
    retrieveAll(fbPageId, 1, 1);
    return () => resetAllContacts();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        All my Leads — {totalContacts?.toLocaleString('en-US')}
        <div className={styles.buttonsContainer}>
          <Button
            css={{ container: styles.button }}
            disabled={!uploadContactsPermission.isAllowed}
            color="secondary"
            onClick={onImportClick}
          >
            Import
          </Button>
          <Button
            color="secondary"
            onClick={() => showSlideoutMenu('attributesAndTags')}
            css={{ container: styles.button }}
          >
            Attributes and Tags
          </Button>
        </div>
      </div>

      <div className={styles.content}>
        <MyLeadsFiltersPanel
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          busy={busy}
        />
        <div className={styles.contacts}>
          <MyLeadsFilterBar
            filterParams={filterParams}
            setFilterParams={setFilterParams}
          />

          {hasFilters && <Divider style={{ margin: '12px 0px 22px' }} />}

          <MyLeadsContactsTable
            filterParams={filterParams}
            setFilterParams={setFilterParams}
            isFetchingContacts={busy}
          />
        </div>
      </div>
    </div>
  );
};
